import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { CreateOrUpdateJobRequest, HttpResponse, Job } from "@/types";

export function useUpdateJob() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({ request }: { request: CreateOrUpdateJobRequest }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}`;
      const res = await httpClient.patch<
        Job,
        HttpResponse<Job>,
        CreateOrUpdateJobRequest
      >(path, request);

      return res.data;
    },
  });

  return mutation;
}
